interface HeadBoxReportProps {
    headBoxTitle: string;
    headBoxValue: string | number;
}

export default function HeadBoxReport({ headBoxTitle, headBoxValue }: HeadBoxReportProps) {
    return (
        <div className='group relative overflow-hidden rounded border border-gray-200 bg-white shadow-sm transition-all duration-300'>
            <div className="h-1 bg-cbColor" />
                <div className='p-2'>
                <p className="text-gray-900 text-xs truncate">{headBoxTitle}</p>
                <p className="text-sm font-semibold">{headBoxValue}</p>
            </div>
        </div>
    )
}
